"use client";

import { useState, useEffect } from "react";

/**
   mobile: (max-width: 768px)
   tablet: (min-width: 768px) and (max-width: 1024px)
   laptop: (min-width: 1024px) and (max-width: 1440px)
   desktop: (min-width: 1440px)
   large-desktop: (min-width: 2560px)
 */
export function useMediaQuery(query: string): boolean {
   const [matches, setMatches] = useState(false);

   useEffect(() => {
      if (typeof window === "undefined") return;
      const mediaQuery = window.matchMedia(query);
      setMatches(mediaQuery.matches);

      const handler = (event: MediaQueryListEvent) => {
         setMatches(event.matches);
      };

      mediaQuery.addEventListener("change", handler);

      return () => {
         mediaQuery.removeEventListener("change", handler);
      };
   }, [query]);

   return matches;
}
